export { FooterComponent } from './footer/footer.component';
